<template>
  <Layout>
    <template #head>
      <Basics :basics="resume.basics" />
    </template>
    <template #main>
      <Education :education="resume.education" />
      <Work :work="resume.work" />
      <Publications :publications="resume.publications" />
      <Projects :projects="resume.projects" />
      <Volunteer :volunteer="resume.volunteer" />
      <Certificates :certificates="resume.certificates" />
      <Awards :awards="resume.awards" />
      <Interests :interests="resume.interests" />
      <Skills :skills="resume.skills" :categorized-skills="resume.categorizedSkills" skillsTitle="Skills" />
      <Languages :languages="resume.languages" />
      <Additional :additional="resume.additional" />
    </template>
  </Layout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import resume from '@/schemas/json_resume.json'
import Basics from '../../components/BasicsKansasFin.vue'
import Work from '../../components/Work.vue'
import Education from '../../components/Education.vue'
import Skills from '../../components/Skills.vue'
import Projects from '../../components/Projects.vue'
import References from '../../components/References.vue'
import Awards from '../../components/Awards.vue'
import Certificates from '../../components/Certificates.vue'
import Publications from '../../components/Publications.vue'
import Languages from '../../components/Languages.vue'
import Interests from '../../components/Interests.vue'
import Additional from '../../components/Additional.vue'
import Layout from './Layout.vue'
  export default defineComponent({
    name: 'KansasBusinessFinResume',
    components: {
      Basics,
      Work,
      Education,
      Projects,
      References,
      Awards,
      Certificates,
      Publications,
      Languages,
      Interests,
      Layout,
    },
    props: {
      resume: {
        type: Object,
        required: true,
        default: () => resume,
      },
    },
  })
  </script>
